import React from "react";
import "./BaseSelect.scss";
import { InputLabel, Autocomplete, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledAutocomplete = styled(Autocomplete)({
  '& .MuiAutocomplete-inputRoot': {
    padding: '0px 0px',
    textAlign: 'left',
    fontSize: '14px',
  },
});

const BaseSelect = React.forwardRef(
  ({ errorMessage, options, label, onChange, name, ...props }, ref) => {

    const selectedOption = options.find(option => option.value === props.value) || null;
    return (
      <div className="base-select-container">
        <InputLabel htmlFor={props.name} className="label-header" sx={{
          fontWeight: '800', 
          lineHeight: '33.6px',
          color: '#6b7280',
          fontFamily: 'Nunito',
          fontSize: '14px',
          fontStyle: 'normal',
        }}>
          {label}
        </InputLabel>
        <StyledAutocomplete
          ref={ref}
          options={options}
          getOptionLabel={(option) => option.label || ""}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(event, newValue) => {
            onChange({
              target: { name , label: newValue ? newValue.label : "", value: newValue ? newValue.value : "", key: newValue ? newValue.key : "" },
            });
          }}

          renderInput={(params) => (
            <TextField
              {...params}
              error={Boolean(errorMessage[props.name]?.message)}
              helperText={errorMessage[props.name]?.message}
              variant="outlined"
            />
          )}
          value={selectedOption}
          disableClearable
        />
      </div>
    );
  }
);

export default BaseSelect;
